<script lang="tsx">

import {defineComponent, PropType} from "vue";

export const CopyTypeKeys = ["Normal", "Italic", "Black"]
export type CopyType =  typeof CopyTypeKeys[number]

export default defineComponent({
  name: "Copy",
  props: {
    type: {
      type: String as PropType<CopyType>,
      default: "Normal"
    }
  },
  render() {
    return (
      <span class={`copy copy--${this.$props.type}`}
      >
          {this.$slots.default?.()}
      </span>
    )
  }
})
</script>


<style lang="scss" scoped>
@import "src/css/common/index";

@include important {
  .copy {

    // keep in sync with RichTextEditor
    font-family: "SiemensSans", sans-serif;
    font-size: 18px;
    line-height: 28px;
    word-break: break-word;

    &--Italic {
      font-style: italic;
    }

    &--Black {
      font-weight: 900;
    }
  }
}
</style>


